export const en = {
    NO_PATIENTS_FILTER:'No Patients Avaiable With Current Filter.'
} as const;